<div class="row" style="padding:0px 39px 0px 39px;">
  <div class="col-9">
    <div class="search-content">
      <div class="searchbar">
        <input class="search_input" type="text" [(ngModel)]="filter"
          placeholder="Buscar investigaciones, cuentas y transferencias" />
      </div>
    </div>
  </div>
  <div class="col-3">
    <button mat-raised-button color="primary" (click)="createSearch()" class="createbutton">
      <mat-icon>add</mat-icon>
      Iniciar investigación
    </button>
  </div>
</div>
<div class="table-content mat-elevation-z8" style="background-color: white;">
  <div class="table-scroll">
    <div class="table-button">
      <h3 class="title-table-search">Investigaciones</h3>
    </div>
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="investigationType">
        <th mat-header-cell *matHeaderCellDef>Tipo de Investigación</th>
        <td mat-cell *matCellDef="let element">{{ element.investigationType | titlecase}}</td>
      </ng-container>
      <ng-container matColumnDef="reference">
        <th mat-header-cell *matHeaderCellDef>Referencia</th>
        <td mat-cell *matCellDef="let element">{{ element.reference }}</td>
      </ng-container>
      <ng-container matColumnDef="descripcion">
        <th mat-header-cell *matHeaderCellDef>Descripción</th>
        <td mat-cell *matCellDef="let element">{{ element.description }}</td>
      </ng-container>
      <ng-container matColumnDef="creado">
        <th mat-header-cell *matHeaderCellDef>Creacion</th>
        <td mat-cell *matCellDef="let element">{{ element.createdAt | date: 'dd/MM/yyyy hh:mm:ss' }}</td>
      </ng-container>
      <ng-container matColumnDef="actualizado">
        <th mat-header-cell *matHeaderCellDef>Actualizado</th>
        <td mat-cell *matCellDef="let element">{{ element.updatedAt | date: 'dd/MM/yyyy hh:mm:ss' }}</td>
      </ng-container>

      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef>Opciones</th>
        <td mat-cell *matCellDef="let element">
          <div class="options">
            <mat-icon matTooltip="Ver busqueda" class="edit" (click)="onViewClick(element)">visibility</mat-icon>
            <!-- <mat-icon matTooltip="Eliminar busqueda" class="delete" (click)="delete(element)">delete</mat-icon> -->
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="delete(element)">
                <mat-icon>delete</mat-icon>Eliminar</button>
            </mat-menu>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <mat-paginator [pageSizeOptions]="[10, 25, 100]" aria-label="Select page of roles"></mat-paginator>
</div>